import { createRoot } from 'react-dom/client';
import { BetaApp } from './beta/BetaApp.js';

// This is the dedicated public-beta entry point deployed at beta.gamolution.com.
// The normal product UI is intentionally not imported into the public bundle.
const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');
createRoot(root).render(<BetaApp />);

// Prevent Vite from doing a full page reload when HMR reconnects
// after laptop sleep/lock. Accept the module to signal "I'll handle updates"
// so Vite doesn't fall back to a full reload.
if (import.meta.hot) {
  import.meta.hot.accept();
}
